import { DashboardConstants } from '../../actions/constant';

const {
  GET_DASHBOARD_PATIENT_LIST_FAILURE,
  GET_DASHBOARD_PATIENT_LIST_LOADER,
  GET_DASHBOARD_PATIENT_LIST_SUCCESS,
} = DashboardConstants;
const intitialstate: object = {
  response: null,
  isError: false,
  loading: false,
};

export const getDashboardPatientReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_DASHBOARD_PATIENT_LIST_SUCCESS:
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
        loading: false,
      };

    case GET_DASHBOARD_PATIENT_LIST_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };

    case GET_DASHBOARD_PATIENT_LIST_LOADER:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
